import { PRELOADER_START, PRELOADER_FINISH } from 'actions/types';

export default function(state = null, action) {
  switch (action.type) {
    case PRELOADER_START:
    case PRELOADER_FINISH:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/preloader.js